export default __webpack_public_path__ + "static/media/dr-sandra-dono-rounded.4cab4fa6.png";